<template>
    <div class="p-2">
        <div>
            <h1 class="mb-2">{{ $t("titles.productConversions") }}</h1>
            <p class="text-muted">{{ $t("products.conversionsHelp") }}</p>
        </div>
        <div v-if="$store.getters.hasPerm('add_productconversion')">
            <router-link :to="{ name: 'AddProductConversion' }" class="btn btn-primary text-white px-4">{{
                $t("utils.add") }}</router-link>
        </div>
        <div>
            <Table endpoint="/product_conversions" ref="table" class="mt-3">
                <template v-slot:header>
                    <div class="col-lg-4 d-none d-lg-block">{{ $t("products.conversion") }}</div>
                    <div class="col-lg-3 d-none d-lg-block">{{ $t("products.koeficient") }}</div>
                    <div class="col-lg-3 d-none d-lg-block">{{ $t("products.lastChange") }}</div>
                    <div class="col-lg-2 d-none d-lg-block"></div>
                </template>
                <template #row="line">
                    <div class="col-12 col-lg-4">
                        <div class="fw-bold">{{ line.item.source.shorten_name }} → {{ line.item.output.shorten_name }}</div>
                    </div>
                    <div class="col-12 col-lg-3 my-2 my-lg-0">
                        <div v-if="$store.getters.hasPerm('change_productconversion')" class="input-group">
                            <input :value="edits[line.item.id] ?? String(line.item.coeficient).replace('.', ',')"
                                @input="edits[line.item.id] = $event.target.value" type="text" inputmode="decimal"
                                autocomplete="off" class="form-control" />
                            <button type="button" class="btn btn-outline-primary"
                                :disabled="!changed(line.item)" @click="saveConversion(line.item)">
                                {{ $t("utils.save") }}
                            </button>
                        </div>
                        <span v-else class="fw-bold">{{ formatAmount(line.item.coeficient) }}</span>
                        <div class="text-muted small mt-1">
                            {{ $t("products.conversionRule", {
                                source: line.item.source.shorten_name,
                                sourceUnit: line.item.source.measurement_unit,
                                output: line.item.output.shorten_name,
                                outputUnit: line.item.output.measurement_unit,
                                coef: formatAmount(changed(line.item) ? parseAmount(edits[line.item.id]) : line.item.coeficient)
                            }) }}
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 small text-muted">
                        <span v-if="line.item.modified">{{ line.item.modified }}</span>
                        <span v-if="line.item.modified_by">, {{ personName(line.item.modified_by) }}</span>
                    </div>
                    <div class="col-12 col-lg-2 text-lg-end mt-2 mt-lg-0">
                        <button v-if="$store.getters.hasPerm('delete_productconversion')"
                            @click="deleteConversion(line.item)" class="btn btn-sm btn-outline-danger">
                            {{ $t("utils.delete") }}
                        </button>
                    </div>
                </template>
            </Table>
        </div>
    </div>
</template>
<script>
import Table from "@/components/Table.vue";

export default {
    components: {
        Table,
    },
    data() {
        return {
            edits: {},
        }
    },
    methods: {
        changed(item) {
            const value = this.parseAmount(this.edits[item.id]);
            return Number.isFinite(value) && value > 0 && value !== item.coeficient;
        },
        deleteConversion(item) {
            const name = item.source.shorten_name + " → " + item.output.shorten_name;
            if (!confirm(this.$t("products.confirmDeleteConversion", { name }))) {
                return;
            }
            this.$store.getters.api.delete("/product_conversions/" + item.id + "/delete").then(() => {
                this.$refs.table.loadData();
            })
        },
        saveConversion(item) {
            this.$store.getters.api.put("/product_conversions/" + item.id + "/edit", {
                coeficient: this.parseAmount(this.edits[item.id])
            }).then(() => {
                delete this.edits[item.id];
                this.$refs.table.loadData();
            }).catch(() => {
                alert(this.$t("warehouses.entryError"));
            })
        },
        personName(user) {
            const full = [user.first_name, user.last_name].filter(Boolean).join(" ");
            return full || user.username;
        },
    }
}
</script>
